import { isRecord } from "@arti/utilities";

/**
 * Returns true when the provider metadata contains a valid GitHub App
 * installation ID, indicating the app has actually been installed
 * (not just that the provider record exists).
 */
export function hasGitHubAppInstallation(
  metadata: Record<string, unknown> | null | undefined,
): boolean {
  if (!isRecord(metadata)) {
    return false;
  }
  const githubApp = metadata.github_app;
  if (!isRecord(githubApp)) {
    return false;
  }
  const raw = githubApp.installation_id;
  if (typeof raw === "number") {
    return Number.isFinite(raw) && raw > 0;
  }
  if (typeof raw === "string") {
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0;
  }
  return false;
}
